import { PrivacyPolicy } from "../features/privacyPolicy/PrivacyPolicy";
import { SimplePage } from "../features/simplePage/SimplePage";

export const PrivacyPolicyPage: React.FC = () => (
  <SimplePage>
    <PrivacyPolicy />
  </SimplePage>
);
